/**
 * Product Upsell Handlers
 * Global functions for handling product upsell add to cart and variant selection
 */

// Handle variant selection change
window.handleProductUpsellVariantChange = function (selectElement, formId, skipImage) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  const productJsonEl = document.getElementById("ProductJson-" + formId);
  if (!productJsonEl) {
    console.error("Product JSON not found for form:", formId);
    return;
  }

  try {
    const product = JSON.parse(productJsonEl.textContent);
    const selects = form.querySelectorAll('select[name^="options["]');
    const selectedOptions = Array.from(selects).map((s) => s.value);

    // Find matching variant
    const variant = product.variants.find((v) => selectedOptions.every((opt, i) => v.options[i] === opt));

    if (variant) {
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }

      // Update all price displays (button, toggle, and standalone)
      if (variant.price != null) {
        const currency = document.querySelector('meta[name="currency"]')?.content || "USD";
        const formattedPrice = formatMoney(variant.price, currency);
        const container = form.closest('.upsell-product-container, [class*="upsell-product-container-"]');
        if (container) {
          container.querySelectorAll('.upsell-price, [class*="upsell-toggle-price-"], [data-upsell-current-price]').forEach(function (el) {
            el.textContent = formattedPrice;
          });

          const comparePrice = container.querySelector('[data-upsell-compare-price]');
          if (comparePrice) {
            if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
              comparePrice.textContent = formatMoney(variant.compare_at_price, currency);
              comparePrice.hidden = false;
            } else {
              comparePrice.textContent = '';
              comparePrice.hidden = true;
            }
          }
        }
      }
      

      // Update product image to match selected variant
      var img = skipImage ? null : form.querySelector("img");
      if (img) {
        var imgData = variant && variant.featured_image ? variant.featured_image : null;
        if (!imgData && product.featured_image) {
          // Fallback to product featured image
          var fi = product.featured_image;
          imgData = { src: typeof fi === "string" ? fi : fi.src, alt: "" };
        }
        if (imgData && imgData.src) {
          var newSrc = imgData.src.replace(/^\/\//, "https://").split("?")[0] + "?width=150";
          if (newSrc !== img.src) {
            var preload = new Image();
            preload.onload = function () {
              img.src = newSrc;
              if (imgData.alt) img.alt = imgData.alt;
            };
            preload.src = newSrc;
          }
        }
      }
    }

    // Disable unavailable variant option combinations
    selects.forEach(function (currentSelect, idx) {
      Array.from(currentSelect.options).forEach(function (opt) {
        var test = selectedOptions.slice();
        test[idx] = opt.value;
        opt.disabled = !product.variants.some(function (v) {
          return test.every(function (val, i) {
            return v.options[i] === val;
          });
        });
      });
    });
  } catch (error) {
    console.error("Error handling variant change:", error);
  }
};

// Handle add to cart
window.handleProductUpsellAdd = async function (buttonElement, formId) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    console.error("No variant ID found");
    return;
  }

  const cartAction = form.dataset.cartAction || "drawer";

  // Disable button and show loading state
  const originalHTML = buttonElement.innerHTML;
  buttonElement.disabled = true;
  buttonElement.classList.add("is-loading");
  buttonElement.innerHTML = '<span class="button-spinner"></span>';

  try {
    if (cartAction === "redirect") {
      const response = await fetch(window.routes.cart_add_url + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });
      if (!response.ok) throw new Error("Failed to add to cart");
      const text = await response.text();
      const data = JSON.parse(text);
      if (data.status) throw new Error(data.description || "Failed to add to cart");
      window.location = window.routes?.cart_url || "/cart";
      return;
    }

    // Drawer: same request as shop-cart-button-handler (FormData + sections) so we get section HTML and open drawer
    const formData = new FormData(form);
    formData.append("sections", "cart-drawer,cart-icon-bubble");
    formData.append("sections_url", window.location.pathname);

    const response = await fetch(window.routes.cart_add_url, {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      body: formData,
    });

    const text = await response.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error("Cart add returned non-JSON (likely HTML). Response ok:", response.ok, "Status:", response.status);
      throw new Error("Unable to add to cart. Please try again.");
    }
    if (data.status) {
      console.error("Error adding to cart:", data.description);
      throw new Error(data.description || "Error adding product to cart");
    }

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents(data);
    }

    if (typeof upsellCarousel === "function") {
      upsellCarousel();
    }

    // Show success state
    buttonElement.classList.remove("is-loading");
    buttonElement.classList.add("upsell-add-success");
    buttonElement.innerHTML = "✓ Added!";

    // Update cart count bubble
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});

    // Reset button after 2 seconds
    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-success");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  } catch (error) {
    console.error("Error adding to cart:", error);

    // Show error state
    buttonElement.classList.remove("is-loading");
    buttonElement.classList.add("upsell-add-error");
    buttonElement.innerHTML = "✗ Error";

    // Reset button after 2 seconds
    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-error");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  }
};

// Handle toggle switch add/remove from cart
window.handleProductUpsellToggle = async function (toggleElement, formId, uniqueId) {
  // Prevent double-calling
  if (toggleElement.dataset.processing === "true") {
    return;
  }
  toggleElement.dataset.processing = "true";

  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    toggleElement.checked = !toggleElement.checked; // Revert
    toggleElement.dataset.processing = "false";
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    console.error("No variant ID found");
    toggleElement.checked = !toggleElement.checked; // Revert
    toggleElement.dataset.processing = "false";
    return;
  }

  // Use uniqueId to find the toggle switch more reliably
  const toggleSwitch = document.querySelector(".upsell-toggle-switch-" + uniqueId) || toggleElement.parentElement;
  const isAdding = toggleElement.checked;

  const cartAddUrl = window.routes?.cart_add_url || "/cart/add";
  const cartChangeUrl = window.routes?.cart_change_url || "/cart/change";

  // Show loading state
  if (toggleSwitch) {
    toggleSwitch.classList.add("is-loading");
  }

  try {
    if (isAdding) {
      // Add to cart
      const response = await fetch(cartAddUrl + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to add to cart");
      }
    } else {
      // Remove from cart - first get cart to find the line item
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      // Find the item in cart
      const cartItem = cart.items.find((item) => item.variant_id == variantId);

      if (cartItem) {
        // Calculate new quantity (decrease by 1)
        const newQuantity = cartItem.quantity - 1;

        // Update cart
        const response = await fetch(cartChangeUrl + ".js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: variantId.toString(),
            quantity: newQuantity,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to remove from cart");
        }
      }
    }

    // Success - remove loading state
    if (toggleSwitch) {
      toggleSwitch.classList.remove("is-loading");
    }
    toggleElement.dataset.processing = "false";

    // Update cart count bubble
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});

    if (typeof window.refreshCartDrawer === "function") {
      await window.refreshCartDrawer();
    }
  } catch (error) {
    console.error("Error updating cart:", error);

    // Revert toggle state on error
    toggleElement.checked = !toggleElement.checked;
    if (toggleSwitch) {
      toggleSwitch.classList.remove("is-loading");
    }
    toggleElement.dataset.processing = "false";
  }
};

// Event delegation for toggle switches - more reliable than inline handlers
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("change", function (e) {
    if (e.target.classList.contains("upsell-toggle-input")) {
      const formId = e.target.dataset.formId;
      const uniqueId = e.target.dataset.uniqueId;
      if (formId && uniqueId) {
        handleProductUpsellToggle(e.target, formId, uniqueId);
      }
    }
  });
});
// Helper function to format money
function formatMoney(cents, currency = "USD") {
  const amount = cents / 100;

  // Try to use Shopify's money format if available
  if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.money_format || "{{amount}}");
  }

  // Fallback formatting
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(amount);
}

// Swatch / Pill tıklama handler
window.upsellSwatchClick = function(btn, formId) {
  var optionName = btn.getAttribute('data-option-name');
  var value = btn.getAttribute('data-value');
  var form = document.getElementById(formId);
  if (!form) return;

  // Selected class'ı güncelle — aynı gruptaki tüm butonlardan kaldır
  var allGroups = form.querySelectorAll('[data-option-name="' + optionName + '"] button, [data-option-name] button');
  var group = btn.parentElement;
  if (group) {
    group.querySelectorAll('button').forEach(function(b) {
      // Swatch seçili class
      b.className = b.className.split(' ').filter(function(cls) {
        return !cls.includes('-selected-');
      }).join(' ');
    });
  }
  // Bu butona selected ekle — mevcut class'taki uid'yi bul
  var existingClass = btn.className;
  var baseClass = existingClass.split(' ').find(function(c) { return c.includes('upsell-swatch-btn') || c.includes('upsell-pill-btn'); });
  if (baseClass) {
    var uid = baseClass.replace('upsell-swatch-btn-','').replace('upsell-pill-btn-','');
    if (existingClass.includes('swatch-btn')) {
      btn.classList.add('upsell-swatch-selected-' + uid);
    } else {
      btn.classList.add('upsell-pill-selected-' + uid);
    }
  }

  // Product JSON'dan tüm seçili değerleri topla ve variant bul
  var productJsonEl = document.getElementById('ProductJson-' + formId);
  if (!productJsonEl) return;

  try {
    var product = JSON.parse(productJsonEl.textContent);

    // Tüm option değerlerini topla (select + swatch/pill butonlar)
    var selectedOptions = {};

    // Select'lerden
    form.querySelectorAll('select[name^="options["]').forEach(function(sel) {
      var name = sel.name.replace('options[','').replace(']','');
      selectedOptions[name] = sel.value;
    });

    // Swatch/pill butonlardan (selected class'lı olanlar)
    form.querySelectorAll('[class*="upsell-swatch-group"], [class*="upsell-pill-group"]').forEach(function(grp) {
      var oName = grp.getAttribute('data-option-name');
      var selectedBtn = grp.querySelector('button[class*="-selected-"]');
      if (selectedBtn) {
        selectedOptions[oName] = selectedBtn.getAttribute('data-value');
      }
    });

    // Bu tıklamayı da ekle (henüz DOM güncellenmemiş olabilir)
    selectedOptions[optionName] = value;

    // Variant eşleştir
    var match = product.variants.find(function(v) {
      return product.options.every(function(opt, i) {
        var sel = selectedOptions[opt];
        if (!sel) return true; // tanımsızsa geç
        return v['option' + (i + 1)] === sel;
      });
    });

    if (match) {
      // hidden input'u güncelle
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;

      // Görseli güncelle
      var img = form.querySelector('img');
      if (img) {
        var imgData = match.featured_image || null;
        if (!imgData && product.featured_image) {
          var fi = product.featured_image;
          imgData = { src: typeof fi === 'string' ? fi : fi.src, alt: '' };
        }
        if (imgData && imgData.src) {
          var newSrc = imgData.src.replace(/^\/\//, 'https://').split('?')[0] + '?width=150';
          if (newSrc !== img.src) {
            var preload = new Image();
            preload.onload = function() {
              img.src = newSrc;
              if (imgData.alt) img.alt = imgData.alt;
            };
            preload.src = newSrc;
          }
        }
      }

      // Fiyatı güncelle
      if (match.price != null) {
        var currency = document.querySelector('meta[name="currency"]')?.content || 'EUR';
        var formattedPrice = formatMoney(match.price, currency);
        var container = form.closest('[class*="upsell-wrap-"]') || form.parentElement;
        if (container) {
          container.querySelectorAll('[class*="upsell-price-"]').forEach(function(el) {
            if (!el.className.includes('upsell-price-row') && !el.className.includes('upsell-compare')) {
              el.textContent = formattedPrice;
            }
          });
        }
      }
    }
  } catch(e) {
    console.error('Upsell swatch error:', e);
  }
};